/**
 * Componente raiz: router, sesion del SSO y layout.
 */

import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@presentation/components/common';
import { AuthProvider } from '@presentation/context/AuthContext';
import { AppRouter } from '@presentation/router';
import { Header, Footer } from '@presentation/components/layout';

export function App() {
  return (
    <ErrorBoundary>
      {/* El router envuelve al proveedor de sesion: el Header navega y el
          callback de login necesita las rutas ya montadas. */}
      <BrowserRouter>
        <AuthProvider>
          <div className="app-container">
            <Header />
            <AppRouter />
            <Footer />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
